import React from "react";
import { Alert } from "@showitinc/showit-wc";

import HelpConstants from "../constants/HelpConstants";

function BlogSEOSection(props) {
  return (
    <Alert
      variant="info"
      stacked
      weight="bold"
      message="SEO settings for blog posts and pages can be modified using the Yoast SEO plugin in your WordPress admin."
      ctaText="Learn More"
      ctaLink={HelpConstants.URL_BLOG_SEO_CONFIG}
    />
  );
}

export default BlogSEOSection;
